import React from 'react';

// Fonction pour déterminer l'attribut autoComplete approprié pour les selects
const getAutoComplete = (name) => {
  const autoCompleteMap = {
    genre: 'sex',
    sex: 'sex',
    diplome: 'off',
    statutEntree: 'off',
    statutInsertion: 'off',
    typeFormation: 'off',
    filiere: 'off',
    typeContrat: 'off',
    formateur: 'off',
    promotion: 'off',
    entreprise: 'organization',
    poste: 'organization-title',
    appreciation: 'off',
    type: 'off'
  };

  return autoCompleteMap[name?.toLowerCase()] || 'off';
};

const FormSelect = ({ label, value, onChange, required, options = [], placeholder = 'Sélectionner', error, onAddNew, addLabel, name, id, ...props }) => {
  // Générer un ID unique basé sur le name ou utiliser celui fourni
  const selectId = id || (name ? `select-${name}` : `select-${Math.random().toString(36).substr(2, 9)}`);
  const autoComplete = getAutoComplete(name);

  return (
    <div>
      {label && (
        <label htmlFor={selectId} className="block text-sm font-medium mb-1">
          {label} {required && <span className="text-red-600">*</span>}
        </label>
      )}
      <div className="flex gap-2">
        <select
          id={selectId}
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          autoComplete={autoComplete}
          className={`flex-1 px-3 py-2 border rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 ${
            error ? 'border-red-500' : 'border-gray-300'
          }`}
          {...props}
        >
          <option value="">{placeholder}</option>
          {options.map((option, index) => (
            <option key={index} value={typeof option === 'string' ? option : option.value}>
              {typeof option === 'string' ? option : option.label}
            </option>
          ))}
        </select>
        {onAddNew && (
          <button
            type="button"
            onClick={onAddNew}
            className="px-3 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
            aria-label={addLabel || 'Ajouter une nouvelle option'}
          >
            {addLabel || '+'}
          </button>
        )}
      </div>
      {error && <p className="mt-1 text-sm text-red-600" role="alert">{error}</p>}
    </div>
  );
};

export default FormSelect;

